import { defineMessages } from "react-intl";
export default defineMessages({
    addAlert: {
        id: "alerts.addAlert",
        defaultMessage: "Add alert",
    },
    addCondition: {
        id: "alerts.addCondition",
        defaultMessage: "Add condition",
    },
    alertAdded: {
        id: "alerts.alertAdded",
        defaultMessage: "Alert successfully added",
    },
    alertAuthorizationNotice: {
        id: "alerts.alertAuthorizationNotice",
        defaultMessage: "Alerts work only if you authorize SmartMixin to display notifications",
    },
    alertDeleted: {
        id: "alerts.alertDeleted",
        defaultMessage: "Alert successfully deleted",
    },
    alertEdited: {
        id: "alerts.alertEdited",
        defaultMessage: "Alert successfully modified",
    },
    alertName: {
        id: "alerts.alertName",
        defaultMessage: "Alert name",
    },
    alertWhen: {
        id: "alerts.alertWhen",
        defaultMessage: "I want to be alerted when:",
    },
    aqiGreaterThan: {
        id: "alerts.aqiGreaterThan",
        defaultMessage: "AQI greater than",
    },
    aqiGreaterThanThreshold: {
        id: "alerts.aqiGreaterThanThreshold",
        defaultMessage: "AQI greater than {value}{unit} threshold",
    },
    aqiLessThan: {
        id: "alerts.aqiLessThan",
        defaultMessage: "AQI less than",
    },
    aqiLessThanThreshold: {
        id: "alerts.aqiLessThanThreshold",
        defaultMessage: "AQI less than {value}{unit} threshold",
    },
    atLeastOneCondition: {
        id: "alerts.atLeastOneCondition",
        defaultMessage: "You need to add at least one condition",
    },
    co2GreaterThan: {
        id: "alerts.co2GreaterThan",
        defaultMessage: "CO2 greater than",
    },
    co2GreaterThanThreshold: {
        id: "alerts.co2GreaterThanThreshold",
        defaultMessage: "CO2 greater than {value}{unit} threshold",
    },
    co2LessThan: {
        id: "alerts.co2LessThan",
        defaultMessage: "CO2 less than",
    },
    co2LessThanThreshold: {
        id: "alerts.co2LessThanThreshold",
        defaultMessage: "CO2 less than {value}{unit} threshold",
    },
    conditions: {
        id: "alerts.conditions",
        defaultMessage: "Conditions",
    },
    createAlert: {
        id: "alerts.createAlert",
        defaultMessage: "Create alert",
    },
    dailyPrecipitationGreaterThan: {
        id: "alerts.dailyPrecipitationGreaterThan",
        defaultMessage: "Daily precipitation greater than",
    },
    dailyPrecipitationGreaterThanThreshold: {
        id: "alerts.dailyPrecipitationGreaterThanThreshold",
        defaultMessage: "Daily precipitation greater than {value}{unit} threshold",
    },
    deleteAlert: {
        id: "alerts.deleteAlert",
        defaultMessage: "Delete alert",
    },
    editAlert: {
        id: "alerts.editAlert",
        defaultMessage: "Edit alert",
    },
    editCondition: {
        id: "alerts.editCondition",
        defaultMessage: "Edit condition",
    },
    gustSpeedGreaterThan: {
        id: "alerts.gustSpeedGreaterThan",
        defaultMessage: "Gust speed greater than",
    },
    gustSpeedGreaterThanThreshold: {
        id: "alerts.gustSpeedGreaterThanThreshold",
        defaultMessage: "Gust speed greater than {value}{unit} threshold",
    },
    gustSpeedLessThan: {
        id: "alerts.gustSpeedLessThan",
        defaultMessage: "Gust speed less than",
    },
    gustSpeedLessThanThreshold: {
        id: "alerts.gustSpeedLessThanThreshold",
        defaultMessage: "Gust speed less than {value}{unit} threshold",
    },
    heatIndexGreaterThan: {
        id: "alerts.heatIndexGreaterThan",
        defaultMessage: "Heat index greater than",
    },
    heatIndexGreaterThanThreshold: {
        id: "alerts.heatIndexGreaterThanThreshold",
        defaultMessage: "Heat index greater than {value}{unit} threshold",
    },
    heatIndexLessThan: {
        id: "alerts.heatIndexLessThan",
        defaultMessage: "Heat index less than",
    },
    heatIndexLessThanThreshold: {
        id: "alerts.heatIndexLessThanThreshold",
        defaultMessage: "Heat index less than {value}{unit} threshold",
    },
    humidexGreaterThan: {
        id: "alerts.humidexGreaterThan",
        defaultMessage: "Humidex greater than",
    },
    humidexGreaterThanThreshold: {
        id: "alerts.humidexGreaterThanThreshold",
        defaultMessage: "Humidex greater than {value}{unit} threshold",
    },
    humidexLessThan: {
        id: "alerts.humidexLessThan",
        defaultMessage: "Humidex less than",
    },
    humidexLessThanThreshold: {
        id: "alerts.humidexLessThanThreshold",
        defaultMessage: "Humidex less than {value}{unit} threshold",
    },
    humidityGreaterThan: {
        id: "alerts.humidityGreaterThan",
        defaultMessage: "Humidity greater than",
    },
    humidityGreaterThanThreshold: {
        id: "alerts.humidityGreaterThanThreshold",
        defaultMessage: "Humidity greater than {value}{unit} threshold",
    },
    humidityLessThan: {
        id: "alerts.humidityLessThan",
        defaultMessage: "Humidity less than",
    },
    humidityLessThanThreshold: {
        id: "alerts.humidityLessThanThreshold",
        defaultMessage: "Humidity less than {value}{unit} threshold",
    },
    inProgress: {
        id: "alerts.inProgress",
        defaultMessage: "In Progress",
    },
    myAlerts: {
        id: "alerts.myAlerts",
        defaultMessage: "My alerts",
    },
    noConfiguredAlert: {
        id: "alerts.noConfiguredAlert",
        defaultMessage: "You don't have any alerts configured yet, start adding one",
    },
    noiseGreaterThan: {
        id: "alerts.noiseGreaterThan",
        defaultMessage: "Noise greater than",
    },
    noiseGreaterThanThreshold: {
        id: "alerts.noiseGreaterThanThreshold",
        defaultMessage: "Noise greater than {value}{unit} threshold",
    },
    noiseLessThan: {
        id: "alerts.noiseLessThan",
        defaultMessage: "Noise less than",
    },
    noiseLessThanThreshold: {
        id: "alerts.noiseLessThanThreshold",
        defaultMessage: "Noise less than {value}{unit} threshold",
    },
    noteOnConditions: {
        id: "alerts.noteOnConditions",
        defaultMessage: "Note that the alert is triggered when all of the below conditions are verified",
    },
    noTriggerHistory: {
        id: "alerts.noTriggerHistory",
        defaultMessage: "This alert hasn't been triggered yet.",
    },
    pm10GreaterThan: {
        id: "alerts.pm10GreaterThan",
        defaultMessage: "PM 10 greater than",
    },
    pm10GreaterThanThreshold: {
        id: "alerts.pm10GreaterThanThreshold",
        defaultMessage: "PM 10 greater than {value}{unit} threshold",
    },
    pm10LessThan: {
        id: "alerts.pm10LessThan",
        defaultMessage: "PM 10 less than",
    },
    pm10LessThanThreshold: {
        id: "alerts.pm10LessThanThreshold",
        defaultMessage: "PM 10 less than {value}{unit} threshold",
    },
    pm1GreaterThan: {
        id: "alerts.pm1GreaterThan",
        defaultMessage: "PM 1 greater than",
    },
    pm1GreaterThanThreshold: {
        id: "alerts.pm1GreaterThanThreshold",
        defaultMessage: "PM 1 greater than {value}{unit} threshold",
    },
    pm1LessThan: {
        id: "alerts.pm1LessThan",
        defaultMessage: "PM 1 less than",
    },
    pm1LessThanThreshold: {
        id: "alerts.pm1LessThanThreshold",
        defaultMessage: "PM 1 less than {value}{unit} threshold",
    },
    pm2p5GreaterThan: {
        id: "alerts.pm2p5GreaterThan",
        defaultMessage: "PM 2.5 greater than",
    },
    pm2p5GreaterThanThreshold: {
        id: "alerts.pm2p5GreaterThanThreshold",
        defaultMessage: "PM 2.5 greater than {value}{unit} threshold",
    },
    pm2p5LessThan: {
        id: "alerts.pm2p5LessThan",
        defaultMessage: "PM 2.5 less than",
    },
    pm2p5LessThanThreshold: {
        id: "alerts.pm2p5LessThanThreshold",
        defaultMessage: "PM 2.5 less than {value}{unit} threshold",
    },
    postStormSummary: {
        id: "alerts.postStormSummary",
        defaultMessage: "Post-storm summary",
    },
    postStormSynopsisHelper: {
        id: "alerts.postStormSynopsisHelper",
        defaultMessage: "You'll get a summary notification after each rain storm ends.",
    },
    postStormSynopsisSoleCondition: {
        id: "alerts.postStormSynopsisSoleCondition",
        defaultMessage: "A post-storm summary can't be combined with other conditions.",
    },
    precipitationGreaterThan: {
        id: "alerts.precipitationGreaterThan",
        defaultMessage: "Hourly precipitation greater than",
    },
    precipitationGreaterThanThreshold: {
        id: "alerts.precipitationGreaterThanThreshold",
        defaultMessage: "Hourly precipitation greater than {value}{unit} threshold",
    },
    rainRateGreaterThan: {
        id: "alerts.rainRateGreaterThan",
        defaultMessage: "Rain rate greater than",
    },
    rainRateGreaterThanThreshold: {
        id: "alerts.rainRateGreaterThanThreshold",
        defaultMessage: "Rain rate greater than {value}{unit} threshold",
    },
    pressureGreaterThan: {
        id: "alerts.pressureGreaterThan",
        defaultMessage: "Pressure greater than",
    },
    pressureGreaterThanThreshold: {
        id: "alerts.pressureGreaterThanThreshold",
        defaultMessage: "Pressure greater than {value}{unit} threshold",
    },
    pressureLessThan: {
        id: "alerts.pressureLessThan",
        defaultMessage: "Pressure less than",
    },
    pressureLessThanThreshold: {
        id: "alerts.pressureLessThanThreshold",
        defaultMessage: "Pressure less than {value}{unit} threshold",
    },
    solarRadiationGreaterThan: {
        id: "alerts.solarRadiationGreaterThan",
        defaultMessage: "Solar radiation greater than",
    },
    solarRadiationGreaterThanThreshold: {
        id: "alerts.solarRadiationGreaterThanThreshold",
        defaultMessage: "Solar radiation greater than {value}{unit} threshold",
    },
    solarRadiationLessThan: {
        id: "alerts.solarRadiationLessThan",
        defaultMessage: "Solar radiation less than",
    },
    solarRadiationLessThanThreshold: {
        id: "alerts.solarRadiationLessThanThreshold",
        defaultMessage: "Solar radiation less than {value}{unit} threshold",
    },
    stormChartUnavailable: {
        id: "alerts.stormChartUnavailable",
        defaultMessage: "Rain history for this storm is unavailable.",
    },
    stormDetail: {
        id: "alerts.stormDetail",
        defaultMessage: "Storm summary",
    },
    stormDuration: {
        id: "alerts.stormDuration",
        defaultMessage: "Duration",
    },
    stormEnd: {
        id: "alerts.stormEnd",
        defaultMessage: "End",
    },
    stormPeakRate: {
        id: "alerts.stormPeakRate",
        defaultMessage: "Peak rain rate",
    },
    stormStart: {
        id: "alerts.stormStart",
        defaultMessage: "Start",
    },
    stormTotal: {
        id: "alerts.stormTotal",
        defaultMessage: "Total rainfall",
    },
    temperatureGreaterThan: {
        id: "alerts.temperatureGreaterThan",
        defaultMessage: "Temperature greater than",
    },
    temperatureGreaterThanThreshold: {
        id: "alerts.temperatureGreaterThanThreshold",
        defaultMessage: "Temperature greater than {value}{unit} threshold",
    },
    temperatureLessThan: {
        id: "alerts.temperatureLessThan",
        defaultMessage: "Temperature less than",
    },
    temperatureLessThanThreshold: {
        id: "alerts.temperatureLessThanThreshold",
        defaultMessage: "Temperature less than {value}{unit} threshold",
    },
    thswGreaterThan: {
        id: "alerts.thswGreaterThan",
        defaultMessage: "THSW greater than",
    },
    thswGreaterThanThreshold: {
        id: "alerts.thswGreaterThanThreshold",
        defaultMessage: "THSW greater than {value}{unit} threshold",
    },
    thswLessThan: {
        id: "alerts.thswLessThan",
        defaultMessage: "THSW less than",
    },
    thswLessThanThreshold: {
        id: "alerts.thswLessThanThreshold",
        defaultMessage: "THSW less than {value}{unit} threshold",
    },
    thwGreaterThan: {
        id: "alerts.thwGreaterThan",
        defaultMessage: "THW greater than",
    },
    thwGreaterThanThreshold: {
        id: "alerts.thwGreaterThanThreshold",
        defaultMessage: "THW greater than {value}{unit} threshold",
    },
    thwLessThan: {
        id: "alerts.thwLessThan",
        defaultMessage: "THW less than",
    },
    thwLessThanThreshold: {
        id: "alerts.thwLessThanThreshold",
        defaultMessage: "THW less than {value}{unit} threshold",
    },
    triggerHistory: {
        id: "alerts.triggerHistory",
        defaultMessage: "Alert history",
    },
    uvGreaterThan: {
        id: "alerts.uvGreaterThan",
        defaultMessage: "UV index greater than",
    },
    uvGreaterThanThreshold: {
        id: "alerts.uvGreaterThanThreshold",
        defaultMessage: "UV index greater than {value}{unit} threshold",
    },
    uvLessThan: {
        id: "alerts.uvLessThan",
        defaultMessage: "UV index less than",
    },
    uvLessThanThreshold: {
        id: "alerts.uvLessThanThreshold",
        defaultMessage: "UV index less than {value}{unit} threshold",
    },
    visibilityGreaterThanThreshold: {
        id: "alerts.visibilityGreaterThanThreshold",
        defaultMessage: "Visibility greater than {value}{unit} threshold",
    },
    visibilityLessThanThreshold: {
        id: "alerts.visibilityLessThanThreshold",
        defaultMessage: "Visibility less than {value}{unit} threshold",
    },
    visiblityGreaterThan: {
        id: "alerts.visiblityGreaterThan",
        defaultMessage: "Visibility greater than",
    },
    visiblityLessThan: {
        id: "alerts.visiblityLessThan",
        defaultMessage: "Visibility less than",
    },
    whichMeasure: {
        id: "alerts.whichMeasure",
        defaultMessage: "Which measure would you like to be alerted for?",
    },
    whichModule: {
        id: "alerts.whichModule",
        defaultMessage: "Which module would you like to be alerted for?",
    },
    windChillGreaterThan: {
        id: "alerts.windChillGreaterThan",
        defaultMessage: "Wind chill greater than",
    },
    windChillGreaterThanThreshold: {
        id: "alerts.windChillGreaterThanThreshold",
        defaultMessage: "Wind chill greater than {value}{unit} threshold",
    },
    windChillLessThan: {
        id: "alerts.windChillLessThan",
        defaultMessage: "Wind chill less than",
    },
    windChillLessThanThreshold: {
        id: "alerts.windChillLessThanThreshold",
        defaultMessage: "Wind chill less than {value}{unit} threshold",
    },
    windSpeedGreaterThan: {
        id: "alerts.windSpeedGreaterThan",
        defaultMessage: "Wind speed greater than",
    },
    windSpeedGreaterThanThreshold: {
        id: "alerts.windSpeedGreaterThanThreshold",
        defaultMessage: "Wind speed greater than {value}{unit} threshold",
    },
    windSpeedLessThan: {
        id: "alerts.windSpeedLessThan",
        defaultMessage: "Wind speed less than",
    },
    windSpeedLessThanThreshold: {
        id: "alerts.windSpeedLessThanThreshold",
        defaultMessage: "Wind speed less than {value}{unit} threshold",
    },
});
